<script>
    import API from '../../../services/api.svelte.js';
    import {notificate} from '../../../services/notification.js';
    import blockedEmails from '../../../services/blocked_emails.js';
    import { goto } from '@roxi/routify';

    let loading = false;
    let register_success = false;

    let formData = {
        name: null,
        organization: null,
        email: null,
        position: null,
        employee_count: null,
        phone: null,
    }

    const signUp = async (formData = {}) =>{
        loading = true;

        if(formHasErrors(formData)){
            loading = false;
            return;
        }

        if(formData.employee_count) {
            let emp_count = parseInt(formData.employee_count);
            formData.employee_count = emp_count;
        }

        API.signUp("signup", formData)
            .then(async (response)=>{
                if(response.status == 200){
                    register_success = true;
                    loading = false;
                    $goto('login/register_request_success?from=modal');
                }
                if(!response.ok){
                    let errors = await response.json();
                    if(errors.detail){
                        let e = errors.detail.split(",");
                        e.some(string=>{
                            if(string == 'email_already_exists'){
                                notificate("register_email_exists", "toast");
                            }
                        })
                    }
                }
            })
            .catch((errors)=> errors);
        loading = false;
    }

    /*
        Form validation func (all fields required + valid email validation withr regex +
        company email validation (see src/services/blocked_emails.js))

        @param formData
        @returns true | false

    */
    const formHasErrors = (formData) => {

        if( !formData.name                                  ||
            !formData.organization                          ||
            !formData.email                                 ||
            emailValidation(formData.email).error
        ){
            loading = false;
            notificate('422');
            return true;
        }
        else {
            return false;
        }
    }

    /*
        Email validation func
        @param email string
        @returns false | error (string)
    */
    const emailValidation = (email) => {
        let error;

        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!re.test(email)){
            return {error: 'Por favor inserte un correo electrónico válido'}
        }
        else {
            error = null;
        }

        let should_block_email = false;

        let mail_domain = email.split('@');

        blockedEmails.forEach(bEmail=>{
            if(mail_domain[1] === bEmail){
                should_block_email = true;
            }
        });

        if(should_block_email){
            return {error: 'Por favor inserte un correo electrónico empresarial'}
        }
        else{
            return {error: false}
        }
    }


</script>
<style>
    .modal.show .modal-dialog{
        max-width: 600px;
    }
    .modal-content{
        background-color: #E5E5E5;
        text-align: center;
    }
    .modal-body{
        padding: 1rem 2rem 1rem 4rem;
        min-height: 500px;
    }

    .d-flex > div{
        flex: 1;
        text-align: left;
    }
    .d-flex div + div{
        margin-left: 10px;
    }

    label{
        font-size: 0.8rem;
        color: #333333;
        text-align: left;
        display: inline-block;
        width: 100%;
    }


    .modal-header{
        text-align: center;
        display: block;
        border-color: #333;
    }

    .btn.btn-primary:hover{
        opacity: 0.8;
    }

    input {
        background: transparent;
        border-top: 0;
        border-left: 0;
        border-right: 0;
        border-bottom-color: #333333;
        border-radius: 0;
        max-width: 85%;
    }

    input:hover,
    input:focus,
    input:active{
        border-color: #FB383B !important;
    }

    input:hover + label,
    input:focus + label,
    input:active + label{
        color: #FB383B !important;
    }

    .btn.btn-primary{
        background: #333333;
        border-radius: 12px;
        border-color: #333333;
        padding-left: 2rem;
        padding-right: 2rem;
        margin-left: -38px;
    }

    .logo-img{
        margin-top: 4px !important;
        height: 48px !important;
    }

    .logo-text{
        font-family: 'Montserrat-bold', sans-serif;
        font-weight: 700;
        position: relative;
        font-size: 14px !important;
    }


    @media (min-width: 768px){
        .logo-text{
            font-size: 20px !important;
        }

    }

    .logo-text small {
        font-size: 10px;
        display: inline-block;
        position: absolute;
        bottom: -12px;
        left: 1px;
        font-family: 'Montserrat', sans-serif;
    }

</style>

<div class="modal fade show" id="modal-default" aria-modal="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <img src="/img/logo-vulseek-black-with-legend.png" alt="Vulseek by securetia" class="brand-image logo-img">
                <!--<span class="brand-text logo-text">Vulseek<small>By Securetia</small></span>-->
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>

            <div class="modal-body">
                <h4 class="text-start mb-3 mt-5"><strong>REGISTRO</strong></h4>
                {#if loading}
                    <div class="overlay text-center">
                        <i class="fas fa-2x fa-sync-alt fa-spin" />
                    </div>
                {:else}
                    {#if !register_success}
                        <form>
                            <div class="mb-3 d-flex">
                                <div>
                                    <input bind:value={formData.name} type="text" class="form-control" id="name"/>
                                    <label for="name">Nombre / Apellido <span class="vlsk-red">*</span></label>
                                </div>
                                <div>
                                    <input bind:value={formData.organization} type="text" class="form-control" id="organization" />
                                    <label for="organization">Empresa / Organización <span class="vlsk-red">*</span></label>
                                </div>
                            </div>

                            <div class="mb-3 d-flex">
                                <div>
                                    <input bind:value={formData.email} type="email" class="form-control" id="email" />
                                    <label for="email">Correo electrónico empresarial<span class="vlsk-red">*</span></label>
                                    {#if formData.email && emailValidation(formData.email).error}<small class="text-danger">{emailValidation(formData.email).error}</small>{/if}
                                </div>

                            </div>
                            <div class="text-start mt-5"><span class="vlsk-red">*</span><small>Requerido</small></div>
                        </form>
                    {/if}
                {/if}
                {#if !register_success}
                    <div style="text-align: left;"><button type="button" class="mt-5 btn btn-default bkg-vlsk-red" on:click={()=>signUp(formData)}>Enviar</button></div>
                {/if}
            </div>
        </div>
    </div>
        <!-- /.modal-content -->
</div>
    <!-- /.modal-dialog -->

